const state = {
	openModal: false,
	loading: false,
}

export default state;
